/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import reactDOM from 'react-dom';

import Toast from '../../common/Toast/Toast';
import { generateUEID } from '../helpers';

interface Props {
  children: JSX.Element;
}

interface ToastInterface {
  id: string;
  message: string;
  type: 'success' | 'error';
}

const ToastContext = createContext({
  pushToast(message: string, type?: 'success' | 'error', duration?: number) {},
});

export const useToast = () => useContext(ToastContext);

export function ToastProvider({ children }: Props) {
  const modalContainer: HTMLElement | null = document.getElementById('modal');
  const [toasts, setToasts] = useState<ToastInterface[]>([]);

  const removeToast = useCallback((id: string) => {
    setToasts((prevState) => [...prevState.filter((el) => el.id !== id)]);
  }, []);

  const pushToast = useCallback(
    (message: string, type: 'success' | 'error' = 'success', duration = 5) => {
      const id = generateUEID();
      setToasts((prevState) => [...prevState, { id, message, type }]);
      setTimeout(() => {
        removeToast(id);
      }, duration * 1000);
    },
    [],
  );

  const value = useMemo(
    () => ({
      pushToast,
    }),
    [pushToast],
  );

  return (
    <ToastContext.Provider value={value}>
      {children}
      {!modalContainer
        ? null
        : reactDOM.createPortal(
            toasts.map((toast) => (
              <Toast
                key={toast.id}
                message={toast.message}
                type={toast.type}
                id={toast.id}
                removeToast={removeToast}
              />
            )),
            modalContainer,
          )}
    </ToastContext.Provider>
  );
}
